module.exports = __webpack_public_path__ + "static/media/S (87).3abe290f.jpg";